import $ from 'jquery';

export default function setupMessages () {

	function setCookie(key, value, expiry=0) { // Expiry in minutes
		var now = new Date();
		var time = now.getTime();
		time += expiry * 60 * 1000;
		now.setTime(time);
		expiry = now.toUTCString();
		console.log(expiry);
		document.cookie = key + '=' + value + ';expires='+ expiry +';path=/;';
	}

	function getCookie(key) {
		var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
		return keyValue ? keyValue[2] : null;
	}

	function removeCookie(key) {
		document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
	}


	// Check cookie
	var alert_cookie = getCookie('alert_cookie');
	if(alert_cookie != 1){
		$('#alert-message__wrapper').css('display', 'block');
		$('#alert-message__wrapper').slideDown(300);
	}

	$('#alert-message__close').on('click', function(e) {
		e.preventDefault();
		$('#alert-message__wrapper').slideUp(300, function(){
			$(this).remove();
		});
		setCookie('alert_cookie',1,0);
	});
}